module.exports = __webpack_public_path__ + "img/thumbnail-creek.805a359c.jpg";